import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StatusChangeOutput, StatusesHistoryService } from 'core/http/project/status/statuses-history.service';
import { Observable } from 'rxjs';

@Injectable()
export class StatusChangeResolver {
  constructor(private statusesHistoryService: StatusesHistoryService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<StatusChangeOutput> {
    const id = route.params.changeGroupId;

    return this.statusesHistoryService.getStatusChange(id);
  }
}
